export default "__VITE_ASSET__CLOzMP1U__"